// Chargement des planches de tuiles et decoupe d'une case.
// Planches : Kenney, CC0 (voir public/tuiles/CREDITS.txt). 16x16 avec 1 px de marge.

const TU = 16;   // taille d'une tuile dans la planche
const PAS = 17;  // 16 + 1 px de marge

const FEUILLES = {
  monde: 'tuiles/monde.png',        // village, forteresse, sanctuaire
  ville: 'tuiles/ville.png',        // Cluster Hub, Network Realm
  interieur: 'tuiles/interieur.png',
  perso: 'tuiles/perso.png',
};

const images = {};
let pretes = false;

// ⚠️ Plusieurs tuiles de la planche « ville » ont encore un fond magenta au lieu
// d'etre detourees. Sans ce nettoyage, on colle des rectangles roses sur la carte.
function sansMagenta(img) {
  const c = document.createElement('canvas');
  c.width = img.width; c.height = img.height;
  const x = c.getContext('2d', { willReadFrequently: true });
  x.drawImage(img, 0, 0);
  try {
    const d = x.getImageData(0, 0, c.width, c.height);
    const p = d.data;
    for (let i = 0; i < p.length; i += 4) {
      if (p[i] > 200 && p[i + 1] < 60 && p[i + 2] > 200) p[i + 3] = 0;
    }
    x.putImageData(d, 0, 0);
  } catch (e) { console.warn('KubeWorld: nettoyage du magenta impossible', e); }
  return c;
}

const charger = (src) => new Promise((ok, ko) => {
  const i = new Image();
  i.onload = () => ok(i);
  i.onerror = () => ko(new Error('planche introuvable : ' + src));
  i.src = src;
});

async function chargerAtlas() {
  if (pretes) return true;
  const noms = Object.keys(FEUILLES);
  const chargees = await Promise.all(noms.map((n) => charger(FEUILLES[n])));
  noms.forEach((n, i) => { images[n] = sansMagenta(chargees[i]); });
  pretes = true;
  return true;
}

const atlasPret = () => pretes;

// Dessine une case de la planche. (col,row) sont les coordonnees lisibles dans
// l'atelier de reperage : scripts/../.mockup/atlas.html.
function dessinerTuile(ctx, feuille, col, row, dx, dy, taille) {
  const img = images[feuille];
  if (!img) return;
  ctx.drawImage(img, col * PAS, row * PAS, TU, TU, dx, dy, taille, taille);
}

// Comme dessinerTuile, mais en ecartant une marge de la tuile source.
// ⚠️ Les tuiles de dallage ont un joint peint sur leur bord. Repetees, ces joints
// s'alignent et fabriquent une grille reguliere sur tout l'ecran — le jeu se met a
// ressembler a du papier millimetre. On echantillonne l'interieur de la tuile : le
// joint n'est jamais lu, donc jamais repete.
function dessinerInterieur(ctx, feuille, col, row, dx, dy, taille, marge = 1) {
  const img = images[feuille];
  if (!img) return;
  const t = TU - 2 * marge;
  ctx.drawImage(img, col * PAS + marge, row * PAS + marge, t, t, dx, dy, taille, taille);
}

export { chargerAtlas, atlasPret, dessinerTuile, dessinerInterieur, images, TU, PAS };
